var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('ul',{staticClass:"nav"}),_c('div',{staticClass:"copyright"},[_vm._v("\n      © "+_vm._s(_vm.year)+", Powered by\n      "),_c('a',{attrs:{"href":"https://vectolabs.com","target":"_blank"}},[_vm._v("Vectolabs Technologies Sdn Bhd")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }